const request = {}

request.createRequest = function (params) {
  return {
    salePaymentDate: params.date,
    salePaymentPrice: String(params.notPayAmount),
    salePaymentMethodId: params.method.value
  }
}
export default { request }
